import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import axios from "../../api/axiosInstance";
import { useNavigate } from "react-router-dom";

// Simple pen icon SVG for the edit button
const EditIcon = () => (
  <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="#D7BCA7" strokeWidth="1.5">
    <rect x="3" y="3" width="14" height="14" rx="2" fill="none"/>
    <path d="M7 13l6-6M12 7l1 1M13 8l-1-1" />
  </svg>
);

export default function ProfilePage() {
  const navigate = useNavigate();
  const [profile, setProfile] = useState({
    first_name: "",
    last_name: "",
    email_address: "",
    mobile: "",
    address_street: "",
    address_line2: "",
    address_city: "",
    address_postal: "",
    mailing_street: "",
    mailing_line2: "",
    mailing_city: "",
    mailing_postal: "",
    is_mailing_same: false,
    children: [],
  });

  const fetchProfile = async () => {
    try {
      const response = await axios.get("/v1/profile/getBuddyProfile");
      if (response.data.status !== "success") {
        throw new Error("Failed to fetch profile data");
      }
      setProfile(response.data.data.profile);
    } catch (error) {
      console.error(error);
    }
  };


  
const handleEditChild = (childId) => {
  const encodedId = btoa(String(childId)); // base64 encode child ID
  navigate(`/child/${encodedId}`);
};

  useEffect(() => {
    fetchProfile();
  }, []);

  return (
    <>
      <Navbar />
      <div
        style={{
          background: "#FFF9F4",
          width: "96%",
          margin: "30px auto",
          borderRadius: "4px",
          boxSizing: "border-box",
          padding: "20px",
          minHeight: "500px",
        }}
      >
        <div style={{ position: "relative", padding: "18px 20px 0 18px", minHeight: "230px" }}>
          {/* Edit icon */}
          <div style={{ position: "absolute", top: "14px", right: "18px", cursor: "pointer" }}>
            <a href="/profile/edit">
              <EditIcon />
            </a>
          </div>
          <div style={{ letterSpacing: "0.14em", color: "#181818", fontWeight: 700, fontSize: "1rem", marginBottom: "16px" }}>
            PROFILE
          </div>
          <div style={{ fontFamily: "Nunito, sans-serif", color: "#181818", fontSize: "0.98rem", marginBottom: "16px" }}>
            <div style={{ marginBottom: "16px" }}>
              <div>{profile.first_name} {profile.last_name}</div>
              <div style={{ opacity: 0.85 }}>{profile.email_address}</div>
              <div>{profile.mobile}</div>
            </div>
            {/* List Child/Children */}
            {Array.isArray(profile.children) && profile.children.length > 0 && (
              <div>
                {profile.children.map((child, idx) => (
                  <div key={child.id || idx} style={{ marginBottom: "6px" }}>

                    <div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "space-between" }}>
  <div style={{ fontWeight: 600 }}>{child.child_name}</div>
  <button
    onClick={() => handleEditChild(child.id)}
    style={{
      background: "none",
      border: "none",
      padding: 0,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
    }}
    title="Edit child"
  >
    <EditIcon />
  </button>
</div>


                    <div>{child.first_name} {child.last_name}</div>
                    <div style={{ opacity: 0.85, letterSpacing: "0.08em" }}>
                      {child.child_birthdate}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        {/* Separator line */}
        <div style={{
          height: "1px",
          background: "#f2e3d3",
          width: "100%",
          margin: "18px 0 0 0"
        }}/>
        {/* Address section */}
        <div style={{
          display: "flex",
          flexDirection: "row",
          gap: "44px",
          padding: "30px 20px 16px 18px"
        }}>
          <div style={{ flex: 1 }}>
            <div style={{ letterSpacing: "0.14em", color: "#181818", fontWeight: 700, fontSize: "1rem", marginBottom: "16px" }}>
              SHIPPING ADDRESS
            </div>
            <div style={{ fontFamily: "Nunito, sans-serif", color: "#181818", fontSize: "0.98rem" }}>
              <div>{profile.address_street}</div>
              <div>{profile.address_line2}</div>
              <div>
                {profile.address_city}, {profile.address_postal}
              </div>
            </div>
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ letterSpacing: "0.14em", color: "#181818", fontWeight: 700, fontSize: "1rem", marginBottom: "16px" }}>
              MAILING ADDRESS
            </div>
            <div style={{ fontFamily: "Nunito, sans-serif", color: "#181818", fontSize: "0.98rem" }}>
              <div>{profile.mailing_street}</div>
              <div>{profile.mailing_line2}</div>
              <div>
                {profile.mailing_city}, {profile.mailing_postal}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
